import { acMesh } from '../products/acMesh.mjs';
import { acMeshProfessional } from '../products/acMeshProfessional.mjs';
import { baseStationXG } from '../products/baseStationXG.mjs';
import { e7 } from '../products/e7.mjs';
import { e7Audience } from '../products/e7Audience.mjs';
import { e7Campus } from '../products/e7Campus.mjs';
import { u7proOutdoorOverviewVariant } from '../products/overview-variants/u7proOutdoorOverviewVariant.mjs';
import { swissArmyKnifeUltra } from '../products/swissArmyKnifeUltra.mjs';
import { u6enterprise } from '../products/u6enterprise.mjs';
import { u6EnterpriseInWall } from '../products/u6EnterpriseInWall.mjs';
import { u6Extender } from '../products/u6Extender.mjs';
import { u6InWall } from '../products/u6InWall.mjs';
import { u6lr } from '../products/u6lr.mjs';
import { u6Mesh } from '../products/u6Mesh.mjs';
import { u6MeshPro } from '../products/u6MeshPro.mjs';
import { u6plus } from '../products/u6plus.mjs';
import { u6pro } from '../products/u6pro.mjs';
import { u7InWall } from '../products/u7InWall.mjs';
import { u7lite } from '../products/u7Lite.mjs';
import { u7lr } from '../products/u7lr.mjs';
import { u7outdoor } from '../products/u7outdoor.mjs';
import { u7pro } from '../products/u7pro.mjs';
import { u7proMax } from '../products/u7proMax.mjs';
import { u7proWall } from '../products/u7ProWall.mjs';
import { u7proXg } from '../products/u7proXg.mjs';
import { u7proXgs } from '../products/u7proXgs.mjs';
"use strict";
const wifiProducts = [/** Enterprise */
e7, e7Campus, e7Audience, /** Flagship */
u7proXgs, u7proXg, u7proMax, u7pro, u7lr, u7lite, u6enterprise, u6pro, u6lr, u6plus, /** In-Wall */
u7proWall, u6EnterpriseInWall, u7InWall, u6InWall, u6Extender, /** Outdoor */
u7proOutdoorOverviewVariant, u7outdoor, u6MeshPro, u6Mesh, acMeshProfessional, acMesh, swissArmyKnifeUltra, baseStationXG
/** June 5th, 2025 request to remove
 * Mega Capacity from overview
 */
// e7AudienceMegaCapacity,
// baseStationXG,
];
export { wifiProducts };
//# sourceMappingURL=wifiProductSet.mjs.map
